<template>
  <v-container fluid>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <v-list-tile @click="showGameDetails = true">
          <v-list-tile-action>
            <v-icon>videogame_asset</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Show Game Details</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-dialog
          v-model="showGameDetails"
          width="500"
        >
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >{{game.name}}</v-card-title>
            <v-card-text>{{game.description}}</v-card-text>
            <v-card-text>Game Code: {{gameOccurrence.code}}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="showGameDetails = false"
              >Dismiss</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-list-tile @click="acceptRegistrations">
          <v-list-tile-action>
            <v-icon>lock_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Accept Registrations</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      dark
      fixed
      app
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Game State: {{gameClientState}}</v-toolbar-title>
      <v-spacer></v-spacer>
      Reveal Final Scores
      <v-btn
        color="green darken-3"
        small
        fab
        
        @click="revealFinalScores"
      >
        <v-icon dark>wb_incandescent</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card
      v-for="categoryItem in game.categories"
      v-bind:key="categoryItem.category.categoryId"
      class="ma-3 pa-3 elevation-4"
    >
      <v-toolbar
        :color="getCategoryColor(categoryItem.category.categoryId)"
        class="white--text"
      >
        <v-icon
          color="white"
          v-show="categoryItem.category.categoryId === gameOccurrence.currentCategoryId"
        >chevron_right</v-icon>
        <v-toolbar-title>Category: {{categoryItem.category.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        Introduce Category
        <v-btn
          color="cyan darken-4"
          fab
          @click="introduceCategory(categoryItem.category.categoryId)"
        >
          <v-icon color="white">input</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <span class="blockquote">{{categoryItem.category.description}}</span>
        <p class="text-xs-right">Category Id: {{categoryItem.category.categoryId}}</p>
      </v-card-text>
      <v-data-table
        hide-actions
        hide-headers
        :items="getQuestionItemsForCategory(categoryItem.category.categoryId)"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr :active="props.item.questionId === gameOccurrence.currentQuestionId">
            <td>
              <v-icon
                class="mr-2"
                v-show="props.item.questionId === gameOccurrence.currentQuestionId"
              >chevron_right</v-icon>
              <span>Question Id: {{props.item.questionId}}</span>
            </td>
            <td>{{props.item.heading}}</td>
            <td>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  color="light-blue darken-4"
                  fab
                  small
                  @click="introduceQuestion(props.item.questionId)"
                >
                  <v-icon color="white">send</v-icon>
                </v-btn>
                <span>Send Question</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  color="light-blue accent-3"
                  fab
                  small
                  @click="awaitingTeamAnswers(props.item.questionId)"
                >
                  <v-icon>lock_open</v-icon>
                </v-btn>
                <span>Open for Answers</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  color="light-grey"
                  fab
                  small
                  @click="popupResendDialog(props.item.heading,props.item.questionId)"
                >
                  <v-icon>replay</v-icon>
                </v-btn>
                <span>Resend to target team</span>
              </v-tooltip>
              <div class="text-xs-center">
                <v-dialog
                  v-model="showResendDialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                    >
                      Resend {{resendQuestionHeading}}
                    </v-card-title>
                    <v-card-text>
                      <p>
                        This will resend the question and open it for answers to only a single team. Helpful if they didn't have their phone on at the time.
                      </p>
                      <div>
                        <v-text-field
                          prepend-icon="group"
                          name="teamName"
                          v-model="resendTeamName"
                          label="Team Name"
                          required
                        ></v-text-field>
                      </div>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        flat
                        @click="resendAndDismiss"
                      >
                        Resend
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </td>
            <td class="text-xs-right">
              <v-btn
                color="secondary"
                outline
                round
                target="_blank"
                :to="{ name: 'ScoreTeamAnswers', params:{ gameOccurrenceId:gameOccurrence.gameOccurrenceId,questionId:props.item.questionId}}"
              >Score Answers
                <v-icon class="ml-2">launch</v-icon>
              </v-btn>
            </td>
          </tr>

        </template>
      </v-data-table>
      <v-btn
        color="blue-grey darken-4"
        dark
        block
        class="mt-4"
        @click="revealCategoryScores(categoryItem.category.categoryId)"
      >Reveal Category Scores
        <v-icon
          right
          dark
        >wb_incandescent</v-icon>
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import GameModel from "../../api/game-model";

export default {
  name: "HostManager",
  props: ["code"],
  data() {
    return {
      hostConnected: false,
      drawer: false,
      showGameDetails: false,
      showResendDialog: false,
      resendTeamName: "",
      resendQuestionId: 0,
      resendQuestionHeading: ""
    };
  },
  methods: {
    ...mapActions("host", [
      "joinGame",
      "acceptRegistrations",
      "introduceCategory",
      "introduceQuestion",
      "awaitingTeamAnswers",
      "revealCategoryScores",
      "revealFinalScores",
      "resendQuestion"
    ]),
    getQuestionItemsForCategory(categoryId) {
      let questions = this.game.questions
        .filter(q => q.question.category.categoryId === categoryId)
        .map(q => {
          return {
            value: false,
            heading: q.question.heading,
            questionId: q.question.questionId
          };
        });
      return questions;
    },
    getCategoryColor(categoryId) {
      if (categoryId === this.gameOccurrence.currentCategoryId) {
        return "green darken-3";
      }
      return "grey darken-1";
    },
    popupResendDialog(questionHeading, questionId){
      this.resendQuestionId = questionId;
      this.resendQuestionHeading = questionHeading;
      this.showResendDialog = true;
    },
    async resendAndDismiss(){
      await this.resendQuestion({questionId: this.resendQuestionId, teamName: this.resendTeamName}).catch(
        e => alert("Bummer, we failed to resend that question... " + e.message)
      );
      this.showResendDialog = false;
    }
  },
  computed: {
    ...mapState("host", {
      apiMessage: state => state.apiMessage,
      game: state => state.game,
      gameOccurrence: state => state.gameOccurrence,
      gameClientState: state => state.gameClientState
    }),
    ...mapGetters("admin", {
      adminToken: "token"
    })
  },
  watch: {},
  async created() {
    await this.joinGame({ code: this.code, adminToken: this.adminToken }).catch(
      e => alert("Bummer, we failed to join you in the game as a host... " + e.message)
    );
    this.hostConnected = true;
  }
};
</script>